import React from "react";
import { Link } from "react-router-dom";
import { SiteFooter } from "../components/SiteFooter";
const listingsBackgroundUrl = "https://cdn.magicpatterns.com/uploads/uNzWJKHkvGkRnzTxbYKf6Q/file_00000000748881f7b50358700ad596a4.png";
const portraitListingsBackgroundUrl = "https://cdn.magicpatterns.com/uploads/1sJRPnc88ovv6rjg6mcGQ4/file_0000000051d881f5a08d1459fff55ae4.png";
export function MlsListings() {
  return <main className="relative min-h-screen w-full overflow-hidden bg-stone-950" data-id="element-91" data-mp="2e1gzkzz8zhy3">
      <picture data-id="element-92" data-mp="2i0zdhbsnisrf">
        <source media="(orientation: portrait)" srcSet={portraitListingsBackgroundUrl} data-id="element-93" data-mp="2i2is6xynsvr3" />
        <img src={listingsBackgroundUrl} alt="Luxury coastal home interior with a television displaying an ocean sunset" className="listings-background h-screen w-full object-cover object-center" data-id="element-94" data-mp="2mzsn2t4thzmb" />
      </picture>
      <Link to="/?view=links" className="absolute left-5 top-5 rounded-md border border-amber-950/60 bg-amber-100/90 px-4 py-2 text-sm font-bold text-black shadow-md transition-[background-color,border-color] duration-200 hover:border-amber-950 hover:bg-amber-50 sm:left-8 sm:top-8" data-id="element-95" data-mp="2czcem6k1yqi">
        Back to links
      </Link>
      <div className="absolute inset-x-0 bottom-0 z-10" data-id="element-96" data-mp="3kx5qnnhu0ewh">
        <SiteFooter data-id="element-97" data-mp="3fz47z3obihlj" />
      </div>
    </main>;
}